import { Plus } from "lucide-react";
import type { KeyboardEvent, PointerEvent } from "react";
import type { SelectionConnectorLayout } from "./selection-connector.js";

export interface SelectionConnectionOverlayProps {
  layout: SelectionConnectorLayout;
  onPointerDown(event: PointerEvent<HTMLButtonElement>): void;
  onPointerUp(event: PointerEvent<HTMLButtonElement>): void;
  onPointerCancel(event: PointerEvent<HTMLButtonElement>): void;
  onKeyboardOpen(): void;
}

export function SelectionConnectionOverlay({
  layout,
  onPointerDown,
  onPointerUp,
  onPointerCancel,
  onKeyboardOpen
}: SelectionConnectionOverlayProps) {
  const outlet = {
    left: layout.outlet.x - layout.bounds.left,
    top: layout.outlet.y - layout.bounds.top
  };
  const onKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    onKeyboardOpen();
  };
  return (
    <div
      className="studio-selection-connector"
      style={{
        left: layout.bounds.left,
        top: layout.bounds.top,
        width: layout.bounds.width,
        height: layout.bounds.height
      }}
    >
      <div className="studio-selection-connector__bounds" aria-hidden="true" />
      <button
        type="button"
        className="studio-selection-connector__outlet"
        aria-label={`从${layout.label}开始连线`}
        style={outlet}
        onPointerDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onPointerDown(event);
        }}
        onPointerUp={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onPointerUp(event);
        }}
        onPointerCancel={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onPointerCancel(event);
        }}
        onKeyDown={onKeyDown}
      >
        <Plus aria-hidden="true" size={16} />
      </button>
    </div>
  );
}
